export const coursesData = [
  "Deep Learning Specialization",
  "Version control with Git",
  "Python for Data Science and AI",
  "Responsive Website Development and Design"
];
